import { useMutation } from '@apollo/client';


import { gql } from '@apollo/client';

export const ADD_TO_CART_MUTATION = gql`
  mutation addToCart($guid: String!, $productId: String!, $quantity: Int!, $loggedInStatus: LoggedInStatus!) {
    addToCart(guid: $guid, productId: $productId, quantity: $quantity, loggedInStatus: $loggedInStatus) {
      success
      message
      cart {
        id
        subTotal {
          value
          formattedValue
        }
        entryNumber
      }
    }
  }
`
export default function useAddToCart() {
  // Add to Cart
  const [addToCart, { data: addToCartData, loading: addToCartLoading, error: addToCartError }] = useMutation(
    ADD_TO_CART_MUTATION
  );

  return {
    addToCartData,
    addToCartLoading,
    addToCartError,
    addToCart,
  };
}
